import React, { useEffect, useState } from "react";
import TableDet from "./TableDet";
import { getDeterminantes } from "../../services/getDeterminantes";

const Determinantes =()=> {
    const [loading, setLoading] = useState(false)
    const[determinantes, setDeterminantes] = useState({})
    const [error, setError] = useState(false)
    useEffect(()=>{
        async function fetchData() {
            setLoading(true)
            try{
                const fetchDeterminantes = await getDeterminantes()
                setDeterminantes(fetchDeterminantes.data)
            }catch(e){
                setError(e)
            }
            setLoading(false)
        }
        fetchData();
    },[])

    return(
        <>
            <p>Publicación diaria donde se detalla el estado de las profundidades de los principales pasos críticos de los ríos Paraná (entre el Km 1210 y el Km 1463,5) y Paraguay, en sus tramos compartidos entre Argentina y Paraguay. Se consignan además los anchos navegables y el kilometraje de las profundidades críticas. La "determinante" hace referencia a la profundidad efectiva mínima informada para la navegación en la zona prevista. Para el cálculo de esta última se considera la última fecha de sondaje por lo que los valores mostrados pueden variar.</p>
            
            
            <p className="fuente-navegacion" >Fuente: Dirección Nacional de Vías Navegables, Distrito Paraná Superior.</p>
            {
                Object.keys(determinantes).length >0 &&
                 <TableDet Parana={determinantes.parana} Paraguay={determinantes.paraguay} />    
            }
        </>
    )
}

export default Determinantes